export default __webpack_public_path__ + "static/media/newpatient.cfd71ac8.svg";